import useReservedCollection from './use-reserved-collection';
import { computed, Ref } from 'vue';

export type ContentsSharedWithMeParams = {
  context: string;
};

const useContentsSharedWithMe = (params: Ref<ContentsSharedWithMeParams>) => {
  const reservedCollectionParams = computed(() => ({
    collectionId: `shared-content:${params.value.context}`,
    name: 'Shared with me', // TODO i18n
    icon: 'history',
    context: params.value.context,
  }));
  const { collection, isLoading, hasContent } = useReservedCollection(reservedCollectionParams);

  return {
    collection,
    isLoading,
    hasContent,
  };
};

export default useContentsSharedWithMe;
